import { isEmpty } from 'lodash'
import React from 'react'
import {Col, Row } from 'reactstrap'

const EntityHeader = ({entityData}) => {
    return (
        <React.Fragment>
            <Row >
                <Col className="col-12 mt-3 mb-3">
                    <h3>{(!isEmpty(entityData) && !isEmpty(entityData.entity_name)) ? entityData.entity_name : ''}</h3>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default EntityHeader